import { render, staticRenderFns } from "./saleProjectCover.vue?vue&type=template&id=9dc9f648&scoped=true"
import script from "./saleProjectCover.vue?vue&type=script&lang=js"
export * from "./saleProjectCover.vue?vue&type=script&lang=js"
import style0 from "./saleProjectCover.vue?vue&type=style&index=0&id=9dc9f648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc9f648",
  null
  
)

export default component.exports